import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import {
  ACL,
  TICKET_TYPES,
  TICKETS_STATUSES
} from "../../../../../config/constants";
import {
  NOTIFICATION_TICKETS_ACTIONS
} from '../../../../../config/notifications';
import { updateTicket } from '../../../../../api/clients/tickets';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function ConfirmDeleteOrganizationTicket(props) {
  const [ showConfirmModal, setShowConfirmModal ] = useState( false );

  const { index, actionCallback, ticket, showIcon } = props;

  const shouldHideActionBtn = () => {
    if (! ticket || ! ACL.CLIENT.TICKETS.MANAGE.hasAccess() || ticket.status !== TICKETS_STATUSES.NEW) {
      return true;
    }
  }

  if ( shouldHideActionBtn()) {
    return null;
  }

  const confirmDeleteOrganizationTicket = () => {
    updateTicket( {
      ticket: ticket.id,
      data: {
        status: TICKETS_STATUSES.APPROVED,
        reason: "",
      },
      notificationId: NOTIFICATION_TICKETS_ACTIONS
    } ).then( (response) => {
      setShowConfirmModal( false );

      if (response && response.data.id) {
        actionCallback();
      }
    });
  };

  const getConfirmTooltipId = () => {
    switch (ticket.type) {
      case TICKET_TYPES.DELETE_ORGANIZATION: {
        return 'components.pages.ticket.table.actionButtons.confirm_delete_ticket';
      }
      default: {
        return 'components.pages.ticket.table.actionButtons.confirm_delete_ticket';
      }
    }
  }

  if (! ticket) {
    return null;
  }

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`confirm-icon-${index}`}
            onClick={() => setShowConfirmModal( true )}
          >
            <FormattedMessage
              id={getConfirmTooltipId()}/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`confirm-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id={getConfirmTooltipId()}/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`confirm-icon-` + props.index}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowConfirmModal( true )
            }}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faCheckDouble}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`confirm-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id={getConfirmTooltipId()}/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showConfirmModal}
        messageId="components.layout.confirmation.body.confirm_delete_organization"
        closeModal={() => setShowConfirmModal( false )}
        confirmationYes={confirmDeleteOrganizationTicket}
      />
    </Fragment>
  );
}

export { ConfirmDeleteOrganizationTicket };
